"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import { FaExchangeAlt, FaUser, FaIdCard, FaHorse, FaMapMarkerAlt, FaBuilding, FaEnvelope } from "react-icons/fa"
import "../styles/TransferirSenha.css"
;
export default function TransferirSenha() {
  const [senhasPagas, setSenhasPagas] = useState([])
  const [senhaSelecionada, setSenhaSelecionada] = useState(null)
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({
    emailNovoDono: "",
    nomeVaqueiro: "",
    cpf: "",
    nomeEsteira: "",
    cavaloPuxar: "",
    cavaloEsteira: "",
    representacao: "",
    cidade: "",
  })

  useEffect(() => {
    const carregarSenhas = async () => {
      setLoading(true)
      try {
        const token = localStorage.getItem("token")
        const user = JSON.parse(localStorage.getItem("user"))

        if (!user || !user._id) return

        const { data } = await axios.get(`https://api.ticketdovaqueiro.com/api/pedidos/usuario/${user._id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })

        const senhas = []
        data.forEach((pedido) => {
          if (pedido.status === "reservado" && pedido.statusPagamento === "pago") {
            pedido.senhas.forEach((s) => {
              senhas.push({
                ...s,
                pedidoId: pedido._id,
                categoria: pedido.categoria,
                evento: pedido.evento,
                valorPago: pedido.total / pedido.senhas.length,
              })
            })
          }
        })

        setSenhasPagas(senhas)
      } catch (error) {
        console.error("Erro ao carregar senhas:", error)
      } finally {
        setLoading(false)
      }
    }

    carregarSenhas()
  }, [])

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const buscarSenhaIdReal = async () => {
    const { numero, categoria, evento } = senhaSelecionada

    const { data } = await axios.get(
      `https://api.ticketdovaqueiro.com/api/senhas/reservadas/${evento._id || evento}/${categoria}`,
    )

    const senhaReal = data.find((s) => s.numero === numero)

    if (!senhaReal) throw new Error("Senha real não encontrada")

    return senhaReal._id
  }

  const transferir = async () => {
    if (!senhaSelecionada || !form.emailNovoDono) {
      return alert("Selecione uma senha e preencha o e-mail do novo dono.")
    }

    setLoading(true)
    try {
      const senhaId = await buscarSenhaIdReal()

      await axios.post(
        "https://api.ticketdovaqueiro.com/api/senhas/transferir",
        {
          senhaId,
          emailNovoUsuario: form.emailNovoDono,
          nomeVaqueiro: form.nomeVaqueiro,
          cpf: form.cpf,
          nomeEsteira: form.nomeEsteira,
          cavaloPuxar: form.cavaloPuxar,
          cavaloEsteira: form.cavaloEsteira,
          representacao: form.representacao,
          cidade: form.cidade,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      )

      alert("Senha transferida com sucesso!")
      setSenhasPagas((prev) => prev.filter((s) => s.numero !== senhaSelecionada.numero))
      setSenhaSelecionada(null)
      setForm({
        emailNovoDono: "",
        nomeVaqueiro: "",
        cpf: "",
        nomeEsteira: "",
        cavaloPuxar: "",
        cavaloEsteira: "",
        representacao: "",
        cidade: "",
      })
    } catch (err) {
      console.error(err)
      alert("Erro ao transferir senha.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="transferir-container">
      <h2 className="transferir-titulo">
        <FaExchangeAlt className="icon-titulo" /> Transferir Senha Individual
      </h2>

      <div className="form-group">
        <label>Selecione uma senha paga:</label>
        <select
          value={senhaSelecionada ? JSON.stringify(senhaSelecionada) : ""}
          onChange={(e) => setSenhaSelecionada(e.target.value ? JSON.parse(e.target.value) : null)}
          disabled={loading}
        >
          <option value="">-- Escolher senha --</option>
          {senhasPagas.map((s) => (
            <option key={s._id} value={JSON.stringify(s)}>
              {`Evento: ${s.evento?.nome || "Sem nome"} | Nº ${s.numero} | Categoria: ${s.categoria}`}
            </option>
          ))}
        </select>
      </div>

      {senhaSelecionada && (
        <div className="dados-container">
          <h4 className="transferir-subtitulo">
            <FaUser className="icon-subtitulo" /> Dados do novo vaqueiro
          </h4>

          <div className="input-group">
            <FaEnvelope className="input-icon" />
            <input
              placeholder="E-mail do novo dono"
              name="emailNovoDono"
              value={form.emailNovoDono}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <FaUser className="input-icon" />
            <input
              placeholder="Nome do vaqueiro"
              name="nomeVaqueiro"
              value={form.nomeVaqueiro}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <FaIdCard className="input-icon" />
            <input placeholder="CPF" name="cpf" value={form.cpf} onChange={handleChange} disabled={loading} />
          </div>

          <div className="input-group">
            <FaUser className="input-icon" />
            <input
              placeholder="Nome do esteira"
              name="nomeEsteira"
              value={form.nomeEsteira}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <FaHorse className="input-icon" />
            <input
              placeholder="Cavalo de puxada"
              name="cavaloPuxar"
              value={form.cavaloPuxar}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <FaHorse className="input-icon" />
            <input
              placeholder="Cavalo da esteira"
              name="cavaloEsteira"
              value={form.cavaloEsteira}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <FaBuilding className="input-icon" />
            <input
              placeholder="Representação"
              name="representacao"
              value={form.representacao}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <FaMapMarkerAlt className="input-icon" />
            <input placeholder="Cidade" name="cidade" value={form.cidade} onChange={handleChange} disabled={loading} />
          </div>

          <button className="botao-transferir" onClick={transferir} disabled={loading}>
            <FaExchangeAlt size={18} />
            {loading ? "Processando..." : "Transferir Senha"}
          </button>
        </div>
      )}
    </div>
  )
}
